"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.operand_matcher = exports.operator_matcher = exports.exp_matcher = void 0;
const pt = __importStar(require("@cicada-lang/partech"));
const matchers = __importStar(require("."));
const Exps = __importStar(require("../../exp"));
const Macros = __importStar(require("../../macros"));
function exp_matcher(tree) {
    return pt.matcher({
        "exp:operator": ({ operator }) => operator_matcher(operator),
        "exp:operand": ({ operand }) => operand_matcher(operand),
    })(tree);
}
exports.exp_matcher = exp_matcher;
function operator_matcher(tree) {
    return pt.matcher({
        "operator:var": ({ name }, { span }) => Exps.Var(pt.str(name), span),
        "operator:ap": ({ target, args_group }, { span }) => pt.matchers
            .one_or_more_matcher(args_group)
            .map((args) => matchers.args_matcher(args))
            .reduce((result, args) => Exps.ApUnfolded(result, args, span), operator_matcher(target)),
        "operator:dot_field": ({ target, name }, { span }) => Exps.Dot(operator_matcher(target), pt.str(name), span),
        "operator:dot_field_quote": ({ target, data }, { span }) => Exps.Dot(operator_matcher(target), pt.trim_boundary(pt.str(data), 1), span),
        "operator:dot_method": ({ target, name, args_group }, { span }) => pt.matchers
            .one_or_more_matcher(args_group)
            .map((args) => matchers.args_matcher(args))
            .reduce((result, args) => Exps.ApUnfolded(result, args, span), Exps.Dot(operator_matcher(target), pt.str(name), pt.span_closure([target.span, name.span]))),
        "operator:dot_method_quote": ({ target, data, args_group }, { span }) => pt.matchers
            .one_or_more_matcher(args_group)
            .map((args) => matchers.args_matcher(args))
            .reduce((result, args) => Exps.ApUnfolded(result, args, span), Exps.Dot(operator_matcher(target), pt.trim_boundary(pt.str(data), 1), pt.span_closure([target.span, data.span]))),
        "operator:sequence": ({ sequence }, { span }) => matchers.sequence_matcher(sequence),
    })(tree);
}
exports.operator_matcher = operator_matcher;
function operand_matcher(tree) {
    return pt.matcher({
        "operand:pi": ({ bindings, ret_t }, { span }) => Exps.PiUnfolded(matchers.pi_bindings_matcher(bindings), exp_matcher(ret_t), span),
        "operand:pi_forall": ({ bindings, ret_t }, { span }) => Exps.PiUnfolded(matchers.pi_bindings_matcher(bindings), exp_matcher(ret_t), span),
        "operand:fn": ({ bindings, ret }, { span }) => Exps.FnUnfolded(matchers.fn_bindings_matcher(bindings), exp_matcher(ret), span),
        "operand:fn_function": ({ bindings, sequence }, { span }) => Exps.FnUnfolded(matchers.fn_bindings_matcher(bindings), matchers.sequence_matcher(sequence), span),
        "operand:fn_function_with_ret_type": ({ bindings, ret_type, sequence }, { span }) => Exps.FnUnfoldedWithRetType(matchers.fn_bindings_matcher(bindings), exp_matcher(ret_type), matchers.sequence_matcher(sequence), span),
        "operand:sigma_exists": ({ bindings, cdr_t }, { span }) => Exps.SigmaUnfolded(matchers.sigma_bindings_matcher(bindings), matchers.exp_matcher(cdr_t), span),
        "operand:cons": ({ car, cdr }, { span }) => Exps.Cons(exp_matcher(car), exp_matcher(cdr), span),
        "operand:quote": ({ data }, { span }) => Exps.Quote(pt.trim_boundary(pt.str(data), 1), span),
        "operand:clazz": ({ bindings }, { span }) => Exps.ClazzUnfolded(pt.matchers
            .zero_or_more_matcher(bindings)
            .map(matchers.clazz_binding_matcher), undefined, span),
        "operand:objekt": ({ properties, last_property }, { span }) => Exps.ObjektUnfolded([
            ...pt.matchers
                .zero_or_more_matcher(properties)
                .map(matchers.property_matcher),
            matchers.property_matcher(last_property),
        ], span),
        "operand:new": ({ name, properties, last_property }, { span }) => Exps.NewUnfolded(pt.str(name), [
            ...pt.matchers
                .zero_or_more_matcher(properties)
                .map(matchers.property_matcher),
            matchers.property_matcher(last_property),
        ], span),
        "operand:new_ap": ({ name, args }, { span }) => Exps.NewAp(pt.str(name), matchers.args_matcher(args), span),
        "operand:equivalent": ({ type, from, rest }, { span }) => Exps.MacroEmbedded(new Macros.Equivalent(matchers.exp_matcher(type), matchers.exp_matcher(from), pt.matchers
            .zero_or_more_matcher(rest)
            .map(matchers.equivalent_entry_matcher), span), span),
    })(tree);
}
exports.operand_matcher = operand_matcher;
//# sourceMappingURL=exp_matcher.js.map